import { isBadCoverUrl, isCoverProxyUrl } from './coverArt';
import { qobuzStaticCoverUrl } from './qobuzStaticCoverUrl';

/** Display art for a recents row — including production rows with artwork_url null. */
export function recentAlbumArtworkUrl(album: {
  artwork_url?: string | null;
  album_id?: string | null;
} | null | undefined): string | null {
  const raw = album?.artwork_url;
  if (raw && !isBadCoverUrl(raw) && !isCoverProxyUrl(raw)) return raw;
  return qobuzStaticCoverUrl(album?.album_id);
}
